module.exports = "/images/loader.gif?f4e2a79fc931eadd12e79698e3c84450";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.gif
// module id = 69
// module chunks = 23